export const typeDescriptionGetter = ({ formik, formContext }) => {
  const foundOption = formContext.typeOptions.find(option => option.value === formik.values.type);
  return foundOption ? foundOption.desc : '';
};

export const activityDescriptionGetter = ({ formik, formContext }) => {
  const foundOption = formContext.activityOptions.find(option => option.value === formik.values.activity);
  return foundOption ? foundOption.desc : '';
};

export const slAccountGetter = ({ formik }) => {
  const type = formik.values.type;
  const activity = formik.values.activity;

  return `${type}_${activity}`;
};
